<template>
  <div class="payments-container delivery-timeline">
    <payment-methods></payment-methods>
    <progress-bar
      v-if="processInProgress(process)"
      :btn-large="true"
      :uiBlock="true"
      class="w92"
    ></progress-bar>
    <div class="checkout-buttons" v-else>
      <button
        @click="checkout()"
        class="btn btn-solid btn-block"
        :class="{ disabled: btnDisabled }"
      >
        {{ _T('Place Order') }}
      </button>
      <router-link
        class="btn btn-outline btn-block"
        :to="{
          name: brandStoreRoute('store_page'),
          params: {
            ...brandStoreParams,
          },
        }"
        >{{ _T('Continue shopping') }}</router-link
      >
    </div>
  </div>
</template>

<script>
import Checkout from '@/mixins/Checkout'
export default {
  name: 'DesktopCheckout',
  mixins: [Checkout],
  components: {
    PaymentMethods: () =>
      import('@/components/Blocks/Payment/PaymentMethod.vue'),
    ProgressBar: () => import('@/components/Elements/ProgressBar'),
  },
}
</script>

<style lang="scss" scoped>
.payments-container {
  width: 60%;
  margin: auto;
  margin-bottom: $px200;
  .w92 {
    width: 92%;
    margin-left: auto;
  }
  .checkout-buttons {
    max-width: 92%;
    margin-left: auto;
    display: grid;
    grid-template-columns: 48% 48%;
    gap: 4%;
    .btn-block {
      margin: 0;
    }
  }
}
</style>
